import SchemesService from '../services/grants.service';
import store from '../store/index';
import { computed } from 'vue';
import grantsService from '../services/grants.service';
class SchemesUtils {
  async checkIsNew(id) {
    await SchemesService.getSchemeById(id, true);
    return true;
  }

  translateStatus(statusEng) {
    if (statusEng == 'Closed') return 'Gesloten';
    else if (statusEng == 'Forthcoming' || statusEng == 'Future')
      return 'Aangekondigd';
    else if (statusEng == 'Discontinued') return 'Gestopt';
    else return 'Open';
  }

  formatEuro(amount) {
    var euroScale = Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      maximumFractionDigits: 0,
    });
    return euroScale.format(amount);
  }

  checkIsDefaultSearch() {
    const audiences = computed({
      get: () => store.state.advancedSearch.selectedAudiences,
    });
    const locations = computed({
      get: () => store.state.advancedSearch.selectedLocations,
    });
    //This is just hidden for now, don't remove it:
    /*
    const industries = computed({
      get: () => store.state.advancedSearch.selectedIndustries,
    });
    */
    const purposes = computed({
      get: () => store.state.advancedSearch.selectedPurposes,
    });
    const schemeTypes = computed({
      get: () => store.state.advancedSearch.selectedSchemeTypes,
    });
    const projectTypes = computed({
      get: () => store.state.advancedSearch.selectedProjectTypes,
    });
    const smeString = computed({
      get: () => store.state.advancedFilters.smeString,
    });
    const applicationTermsString = computed({
      get: () => store.state.advancedFilters.termsString,
    });

    const minBudget = computed({
      get: () => store.state.advancedSearch.minBudget,
    });

    const maxBudget = computed({
      get: () => store.state.advancedSearch.maxBudget,
    });

    const scopesString = computed({
      get: () => store.state.advancedFilters.scopesString,
    });
    const orgsIncludeString = computed({
      get: () => store.state.advancedSearch.organisationsIncludeString,
    });

    const orgsExcludeString = computed({
      get: () => store.state.advancedSearch.organisationsExcludeString,
    });

    const startDate = computed({
      get: () => store.state.advancedSearch.startDate,
    });

    const endDate = computed({
      get: () => store.state.advancedSearch.endDate,
    });

    const searchText = computed({
      get: () => store.state.advancedSearch.searchText,
    });

    const isApplyingFilters = computed({
      get: () => store.state.user.isApplyingFilters,
    });

    if (
      audiences.value == '' &&
      locations.value == '' &&
      //This is just hidden for now, don't remove it:
      //industries.value == '' &&
      purposes.value == '' &&
      schemeTypes.value == '' &&
      projectTypes.value == '' &&
      smeString.value == '' &&
      applicationTermsString.value == '' &&
      maxBudget.value == null &&
      minBudget.value == null &&
      scopesString.value == '' &&
      orgsIncludeString.value == '' &&
      orgsExcludeString.value == '' &&
      startDate.value == '' &&
      endDate.value == '' &&
      searchText.value == '' &&
      isApplyingFilters.value == false
    )
      return true;
    return false;
  }

  async searchSchemes() {
    const statusBoxes = computed({
      get: () => store.state.advancedSearch.statusesString,
    });

    const audiences = computed({
      get: () => store.state.advancedSearch.selectedAudiences,
    });
    const locations = computed({
      get: () => store.state.advancedSearch.selectedLocations,
    });
    //This is just hidden for now, don't remove it:
    /*
    const industries = computed({
      get: () => store.state.advancedSearch.selectedIndustries,
    });
    */
    const purposes = computed({
      get: () => store.state.advancedSearch.selectedPurposes,
    });
    const schemeTypes = computed({
      get: () => store.state.advancedSearch.selectedSchemeTypes,
    });
    const projectTypes = computed({
      get: () => store.state.advancedSearch.selectedProjectTypes,
    });
    const smeString = computed({
      get: () => store.state.advancedFilters.smeString,
    });
    const applicationTermsString = computed({
      get: () => store.state.advancedFilters.termsString,
    });

    const minBudget = computed({
      get: () => store.state.advancedSearch.minBudget,
    });

    const maxBudget = computed({
      get: () => store.state.advancedSearch.maxBudget,
    });

    const scopesString = computed({
      get: () => store.state.advancedFilters.scopesString,
    });
    const orgsIncludeString = computed({
      get: () => store.state.advancedSearch.organisationsIncludeString,
    });

    const orgsExcludeString = computed({
      get: () => store.state.advancedSearch.organisationsExcludeString,
    });

    const startDate = computed({
      get: () => store.state.advancedSearch.startDate,
    });

    const endDate = computed({
      get: () => store.state.advancedSearch.endDate,
    });

    const searchText = computed({
      get: () => store.state.advancedSearch.searchText,
    });

    const selectedSort = computed({
      get: () => store.state.advancedSearch.selectedSort,
    });

    /*     store.commit('advancedSearch/updateCurrentPage', 1);
     */ store.commit('advancedFilters/createTermsString');
    store.commit('advancedFilters/createSMEString');
    store.commit('advancedFilters/createScopesString');
    store.commit('advancedSearch/createOrganisationsIncludeString');
    store.commit('advancedSearch/createOrganisationsExcludeString');
    await SchemesService.getSearchResults(
      searchText,
      statusBoxes,
      audiences,
      locations,
      //This is just hidden for now, don't remove it:
      //industries,
      purposes,
      schemeTypes,
      projectTypes,
      smeString,
      applicationTermsString,
      minBudget,
      maxBudget,
      scopesString,
      orgsIncludeString,
      orgsExcludeString,
      startDate,
      endDate,
      selectedSort
    );
  }

  async searchSchemesFavorites() {
    const statusBoxes = computed({
      get: () => store.state.advancedSearch.statusesString,
    });

    const audiences = computed({
      get: () => store.state.user.favoriteAudienceTagsString,
    });
    const locations = computed({
      get: () => store.state.advancedSearch.selectedLocations,
    });
    //This is just hidden for now, don't remove it:
    /*
    const industries = computed({
      get: () => store.state.advancedSearch.selectedIndustries,
    });
    */
    const purposes = computed({
      get: () => store.state.user.favoritePurposesTagsString,
    });
    const schemeTypes = computed({
      get: () => store.state.advancedSearch.selectedSchemeTypes,
    });
    const projectTypes = computed({
      get: () => store.state.advancedSearch.selectedProjectTypes,
    });
    const smeString = computed({
      get: () => store.state.advancedFilters.smeString,
    });
    const applicationTermsString = computed({
      get: () => store.state.advancedFilters.termsString,
    });

    const minBudget = computed({
      get: () => store.state.advancedSearch.minBudget,
    });

    const maxBudget = computed({
      get: () => store.state.advancedSearch.maxBudget,
    });

    const scopesString = computed({
      get: () => store.state.advancedFilters.scopesString,
    });
    const orgsIncludeString = computed({
      get: () => store.state.advancedSearch.organisationsIncludeString,
    });

    const orgsExcludeString = computed({
      get: () => store.state.advancedSearch.organisationsExcludeString,
    });

    const startDate = computed({
      get: () => store.state.advancedSearch.startDate,
    });

    const endDate = computed({
      get: () => store.state.advancedSearch.endDate,
    });

    const searchText = computed({
      get: () => store.state.advancedSearch.searchText,
    });

    const selectedSort = computed({
      get: () => store.state.advancedSearch.selectedSort,
    });

    /*     store.commit('advancedSearch/updateCurrentPage', 1);
     */ store.commit('advancedFilters/createTermsString');
    store.commit('advancedFilters/createSMEString');
    store.commit('advancedFilters/createScopesString');
    store.commit('advancedSearch/createOrganisationsIncludeString');
    store.commit('advancedSearch/createOrganisationsExcludeString');
    await SchemesService.getSearchResults(
      searchText,
      statusBoxes,
      audiences,
      locations,
      //This is just hidden for now, don't remove it:
      //industries,
      purposes,
      schemeTypes,
      projectTypes,
      smeString,
      applicationTermsString,
      minBudget,
      maxBudget,
      scopesString,
      orgsIncludeString,
      orgsExcludeString,
      startDate,
      endDate,
      selectedSort
    );
  }

  async searchNewestSchemes(page, size) {
    await grantsService.searchNewestSchemes(page, size);
  }

  async searchDeadlineSchemes(page, size) {
    await grantsService.searchSchemesByDeadline(page, size);
  }

  async searchNewestSchemesWithTags(
    page,
    size,
    audiences,
    purposes,
    locations
  ) {
    var audiencesStr = audiences;
    var purposesStr = purposes;
    audiencesStr = audiences.join(',');
    purposesStr = purposes.join(',');
    await grantsService.searchNewestSchemesTags(
      page,
      size,
      audiencesStr,
      purposesStr,
      locations
    );
  }

  async searchDeadlineSchemesWithTags(
    page,
    size,
    audiences,
    purposes,
    locations
  ) {
    var audiencesStr = audiences;
    var purposesStr = purposes;
    audiencesStr = audiences.join(',');
    purposesStr = purposes.join(',');
    await grantsService.searchSchemesByDeadlineTags(
      page,
      size,
      audiencesStr,
      purposesStr,
      locations
    );
  }

  async searchSignificantSchemesWithTags(
    page,
    size,
    audiences,
    purposes,
    locations
  ) {
    var audiencesStr = audiences;
    var purposesStr = purposes;
    var locationsStr = locations;
    audiencesStr = audiences.join(',');
    purposesStr = purposes.join(',');
    locationsStr = locations.join(',');
    await grantsService.searchNewestSchemesTags(
      page,
      size,
      audiencesStr,
      purposesStr,
      locationsStr
    );
  }

  async searchSignificantSchemes(page, size) {
    await grantsService.searchSignificantSchemes(page, size);
  }
}

export default new SchemesUtils();
